import React, { useState } from "react";

export default function OurSpecialization() {
  const [showMore1, setShowMore1] = useState(false);
  const [showMore2, setShowMore2] = useState(false);

  return (
    <section className="spec-section my-3">
      <div className="spec-overlay">
        <div className="container">
          <h2 className="spec-title text-center">Our Specialization</h2>

          <div className="row justify-content-center">
            {/* CAPITAL MARKET ADVISORY */}
            <div className="col-lg-6 col-md-6 mb-4 d-flex">
              <div className="spec-card w-100">
                <img
                  src="/assets/img/capitalmarket.jpg"
                  alt="Capital Market Advisory"
                  className="spec-img"
                />

                <h3>Capital Market Advisory</h3>

                <p className="spec-text">
                  Navigate regulatory complexity with confidence through our
                  specialized audit, taxation, and compliance services for
                  capital market participants. We work closely with stock
                  brokers, depository participants, investment advisors,
                  portfolio managers, and proprietary trading firms to ensure
                  full adherence to SEBI regulations, exchange requirements, and
                  tax laws — while strengthening internal controls and
                  governance frameworks.
                </p>

                {showMore1 && (
                  <div className="extra-content">
                    <p>
                      Our expertise spans the entire operational and regulatory
                      lifecycle of capital market intermediaries, enabling
                      clients to operate efficiently, transparently, and in
                      strict compliance with evolving regulatory standards.
                    </p>

                    <h4 className="spec-subtitle">Our Expertise Includes:</h4>

                    <ul className="spec-list">
                      <li>
                        <strong>SEBI & Exchange Audits:</strong>Conducting
                        internal, concurrent, and regulatory audits as
                        prescribed by SEBI, Stock Exchanges, and Depositories.
                      </li>
                      <li>
                        <strong>Broker & DP Compliance:</strong> Ongoing
                        compliance with SEBI regulations, exchange circulars,
                        and depository requirements, including periodic filings
                        and certifications.
                      </li>
                      <li>
                        <strong>Internal Controls & Risk Management:</strong>{" "}
                        Design and review of internal control systems, risk
                        management frameworks, and operational procedures.
                      </li>
                      <li>
                        <strong>Regulatory Reporting & Filings:</strong>
                        Preparation and submission of regulatory reports,
                        certificates, and disclosures to SEBI, Exchanges, and
                        Depositories.
                      </li>
                    </ul>
                  </div>
                )}

                <button
                  className="read-btn"
                  onClick={() => setShowMore1(!showMore1)}
                >
                  {showMore1 ? "Read Less" : "Read More"}
                </button>
              </div>
            </div>

            {/* NCLT & LEGAL SERVICES */}
            <div className="col-lg-6 col-md-6 mb-4 d-flex">
              <div className="spec-card w-100">
                <img
                  src="/assets/img/nclt.jpg"
                  alt="NCLT Cases"
                  className="spec-img"
                />

                <h3>NCLT & Corporate Legal Services</h3>

                <p className="spec-text">
                  Navigate corporate disputes, insolvency matters, and
                  restructuring procedures with confidence through our
                  expert-driven NCLT advisory. We provide comprehensive legal,
                  financial, and strategic support to companies appearing before
                  the National Company Law Tribunal, ensuring swift, compliant,
                  and effective resolutions.
                </p>

                {showMore2 && (
                  <div className="extra-content">
                    <p>
                      Our multidisciplinary team of legal experts, corporate
                      advisors, CAs, and CS professionals handle complex NCLT
                      matters with precision—delivering clarity, risk
                      mitigation, and seamless representation throughout the p
                    </p>

                    <h4 className="spec-subtitle">Our Expertise Includes:</h4>

                    <ul className="spec-list">
                      <li>
                        <strong>
                          Insolvency & Bankruptcy (IBC) Proceedings:
                        </strong>{" "}
                        Advisory and representation for Corporate Insolvency
                        Resolution Process (CIRP), liquidation matters, and
                        revival strategies.
                      </li>
                      <li>
                        <strong>Corporate Disputes:</strong> Handling cases
                        related to oppression, mismanagement, shareholder
                        disputes, and board conflicts.
                      </li>
                      <li>
                        <strong>Mergers, Amalgamations & Restructuring:</strong>{" "}
                        Drafting, filing, and obtaining approvals for schemes
                        under NCLT, including restructuring, compromise, and
                        arrangement.
                      </li>
                      <li>
                        <strong>NCLT Petitions & Documentation:</strong>{" "}
                        End-to-end preparation and filing of petitions,
                        applications, replies, affidavits, and supporting
                        documentation.
                      </li>
                      <li>
                        <strong>
                          Compliance with SEBI, MCA & Listing Regulations:
                        </strong>{" "}
                        Ensuring all statutory requirements are met for
                        companies undergoing NCLT or restructuring processes.
                      </li>
                      <li>
                        <strong>Strategic Advisory:</strong> Guidance on
                        governance, dispute resolution, restructuring viability,
                        and corporate recovery planning.
                      </li>
                    </ul>
                  </div>
                )}

                <button
                  className="read-btn"
                  onClick={() => setShowMore2(!showMore2)}
                >
                  {showMore2 ? "Read Less" : "Read More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
